
import { HTMLAttributes, ReactElement } from "react";
interface Props extends HTMLAttributes<HTMLElement> {
    color?: string;
    myStyle?: string;
}
function Filter({ color, myStyle }: Props): ReactElement {
    return (
        <svg className={myStyle ? myStyle : ""} width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4766_232)">
                <path d="M10.0047 2L5.4186 9.18292M4.86047 2H17.1395C18.1628 2 19 2.81831 19 3.81846V5.81877C19 6.54615 18.5349 7.45538 18.0698 7.91L14.0698 11.3651C13.5116 11.8197 13.1395 12.7289 13.1395 13.4563V17.366C13.1395 17.9115 12.7674 18.6389 12.3023 18.9117L11 19.73C9.7907 20.4574 8.11628 19.6391 8.11628 18.1843V13.3654C8.11628 12.7289 7.74419 11.9106 7.37209 11.456L3.83721 7.81908C3.37209 7.36446 3 6.54615 3 6.00061V3.90938C3 2.81831 3.83721 2 4.86047 2Z" stroke={color ? color : "black"} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_4766_232">
                    <rect width="22" height="22" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
export default Filter;